import { type UpdatePortalSettingsMutation } from "~/gql/mutations/portal.generated";
import { type GetPortalSettingsQuery } from "~/gql/queries/portal.generated";

const applyConfirmedPortalSettings = (
	payload: UpdatePortalSettingsMutation["updatePortalSettings"],
	draft: GetPortalSettingsQuery
): void => {
	if (payload.errors?.length || !draft.portalSettings) return;
	Object.assign(draft.portalSettings, payload.portalSettings);
};

export default applyConfirmedPortalSettings;
